// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueI18n from 'vue-i18n'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '../static/main.css'
import '../src/style/main.scss'
import VueAnalytics from 'vue-analytics'
import VueSanitize from 'vue-sanitize'
import store from '../store'

import enUK from './locales/en-uk/index'

Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(VueI18n)

Vue.use(Vuetify)
VueSanitize.defaults.allowedAttributes.span = ['class']
Vue.use(VueSanitize, {
  allowedTags: VueSanitize.defaults.allowedTags.concat(['span'])
})

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: 'UA-58974640-3',
    router
  })
}

var vueInstance = null

var WebFont = require('webfontloader')
WebFont.load({
  google: {
    families: ['Roboto']
  },
  active: function () { prepareVue() }
})

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages: {en: enUK} // set locale messages
})

function prepareVue () {
  if (vueInstance === null) {
    /* eslint-disable no-new */
    vueInstance = new Vue({
      el: '#app',
      store,
      i18n,
      router,
      components: { App },
      template: '<App/>'
    })
  }
}



// WEBPACK FOOTER //
// ./src/main.js